import styled from "@emotion/styled";

import AccordionList from "metabase/core/components/AccordionList";

export const SelectAccordionList = styled(AccordionList)`
  color: var(--mb-color-brand);
  outline: none;
`;
